import 'bootstrap/dist/css/bootstrap.css';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import { I18nextProvider } from "react-i18next";
import { createRoot } from 'react-dom/client';
import i18n from "./i18n";
import numeral from "numeral";
import "numeral/locales/it";
import WorkerApi from './worker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const language = process.env.REACT_APP_DEFAULT_LANGUAGE as string;

numeral.locale(language);
WorkerApi.setLanguage(language);

const root = rootElement !== null ? createRoot(rootElement) : null;

root?.render(
    <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={baseUrl as string}>
            <App />
        </BrowserRouter>
    </I18nextProvider>);



//registerServiceWorker();